import NavigateProjectContentsAsList from 'viewmodel/NavigateProjectContentsAsListViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';
import { registerDynImportEntry } from 'js/moduleLoader';

registerDynImportEntry('image/cmdSearch16.svg', () => import('image/cmdSearch16.svg'));
registerDynImportEntry('image/miscChevronRight16.svg', () => import('image/miscChevronRight16.svg'));
registerDynImportEntry('image/miscChevronLeftDouble24.svg', () => import('image/miscChevronLeftDouble24.svg'));

const COLLABORATIONSPACE_ID = 'collaborationspace-id';
const ROLE_FILTERS = 'role-filters';
const OWNERSHIP_FILTERS = 'ownership-filters';

export default class DesNavigateProjectContentsAsList extends DesBaseCollabAcc {

    constructor() {
        super(NavigateProjectContentsAsList);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute(COLLABORATIONSPACE_ID);
    }

    get roleFilters() {
        return this.getAttribute(ROLE_FILTERS);
    }

    get ownershipFilters() {
        return this.getAttribute(OWNERSHIP_FILTERS);
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            roleFilters: this.roleFilters,
            ownershipFilters: this.ownershipFilters
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', COLLABORATIONSPACE_ID,
            ROLE_FILTERS, OWNERSHIP_FILTERS ];
    }
}
if (!window.customElements.get('des-navigate-project-contents-as-list')) {
    window.customElements.define(
        'des-navigate-project-contents-as-list',
        DesNavigateProjectContentsAsList
    );
}
